import React, { useState, useEffect, useRef } from "react";
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import { FormattedMessage, useIntl } from 'react-intl';
import { Row, Col, Card } from 'antd'
import Switch from "react-switch";
import { Icon } from 'semantic-ui-react';
import { Tooltip } from 'react-tooltip'

import default_device from '../Device/DeviceDefaultParams.js';
import DeviceForm from '../Device/DeviceForm.js';

import logo_tucky_smartphone from '../../Images/Logo/logo_tucky_smartphone.png';

import img_tucky from '../../Images/Devices/TUCKY.png';
import img_oximeter from '../../Images/Devices/FS20F.png';
import img_tensiometer from '../../Images/Devices/BP2A.png';
import img_thermometer from '../../Images/Devices/AOJ-20.png';
import img_scale from '../../Images/Devices/SCALE.png';
import img_pain from '../../Images/Devices/PAIN_SCALE.png';
import img_healthform from '../../Images/Devices/HEALTHFORM.png';
import img_vni from '../../Images/Devices/RESPIRATION.png';
import img_oxygentherapy from '../../Images/Devices/OXYGEN_MASK.png';

import Utils from "../Common/Utils.js";

const AddDevicePopup = (props) => {

  const intl = useIntl();
  const noAssociationMsg = intl.messages["param.noAssociation"];
  const [displayValidationPopup, setDisplayValidationPopup] = useState(false);
  const [displayDeviceType, setDisplayDeviceType] = useState("");

  const [checkedFever, setCheckedFever] = useState(Boolean(props.profileData.Patient_Data.alerts.fever_alert.activated));
  const [checkedDetach, setCheckedDetach] = useState(Boolean(props.profileData.Patient_Data.alerts.detach_alert.activated));
  const [checkedBattery, setCheckedBattery] = useState(props.profileData.Patient_Data.alerts.battery_alert.activated);
  const [checkedPR, setCheckedPR] = useState(Boolean(props.profileData.Patient_Data.alerts.PR_alert.activated));
  const [checkedSPO2, setCheckedSPO2] = useState(Boolean(props.profileData.Patient_Data.alerts.SPO2_alert.activated));
  const [checkedSystolicHigh, setCheckedSystolicHigh] = useState(Boolean(props.profileData.Patient_Data.alerts.bloodpressure_sys_high_alert.activated));
  const [checkedDiastolicHigh, setCheckedDiastolicHigh] = useState(Boolean(props.profileData.Patient_Data.alerts.bloodpressure_dia_alert.activated));
  const [checkedWeight, setCheckedWeight] = useState(Boolean(props.profileData.Patient_Data.alerts.weight_alert.activated));
  const [checkedPRTension, setCheckedPRTension] = useState(Boolean(props.profileData.Patient_Data.alerts.bloodpressure_PR_alert.activated));

  const [displayFeverThreshold, setFeverThreshold] = useState(props.profileData.Patient_Data.alerts.fever_alert.threshold);
  const [position, setPosition] = useState(props.profileData.Patient_Data.alerts.pos_alert.threshold);

  //const [SPO2Threshold, setSPO2Threshold] = useState(Boolean(props.profileData.Patient_Data.alerts.SPO2_alert.threshold));
  //const [SPO2Delay, setSPO2Delay] = useState(Boolean(props.profileData.Patient_Data.alerts.SPO2_alert.delay));

  //const [PRThreshold, setPRThreshold] = useState(Boolean(props.profileData.Patient_Data.alerts.PR_alert.threshold));
  //const [PRDelay, setPRDelay] = useState(Boolean(props.profileData.Patient_Data.alerts.PR_alert.delay));

  const [displayTensiometerParams, setDisplayTensiometerParams] = useState(props.profileData.Patient_Data.devices.device3.id !== 'dissociate');
  

  const [deviceIdValid, setDeviceIdValid] = useState(false)

  const [newDevice, setNewDevice] = useState({})

  const [selectedHealthformType, setSelectedHealthformType] = useState("");

  const selectHealthformTypeChange = (e) => {
    setSelectedHealthformType(e.target.value)
  }

  const handleValidationPopupDisplay = () => {
    setDisplayValidationPopup(!displayValidationPopup)
  }

  const get_tucky_name = () => {
    return(<FormattedMessage id="device.tucky.name" defaultMessage="Tucky" />)
  }

  const get_oximeter_name = () => {
    return(<FormattedMessage id="device.oximeter.name" defaultMessage="Oximeter" />)
  }

  const get_tensiometer_name = () => {
    return(<FormattedMessage id="device.tensiometer.name" defaultMessage="Tensiometer" />)
  }

  const get_thermometer_name = () => {
    return(<FormattedMessage id="device.thermometer.name" defaultMessage="Thermometer" />)
  }
  
  const get_scale_name = () => {
    return(<FormattedMessage id="device.scale.name" defaultMessage="Scale" />)
  }
  
  const get_pain_name = () => {
    return(<FormattedMessage id="device.pain.name" defaultMessage="Pain scale" />)
  }

  const get_healthform_name = () => {
    return(<FormattedMessage id="device.healthform.name" defaultMessage="Healthform" />)
  }

  const get_niv_name = () => {
    return(<FormattedMessage id="device.niv.name" defaultMessage="Breathing" />)
  }

  const get_oxigentherapy_name = () => {
    return(<FormattedMessage id="device.oxigentherapy.name" defaultMessage="Breathing" />)
  }

  const get_tucky_desc = () => {
    return(<FormattedMessage id="device.tucky.desc" defaultMessage="Patch thermometer (TUCKY-21)" />)
  }

  const get_oximeter_desc = () => {
    return(<FormattedMessage id="device.oximeter.desc" defaultMessage="Connected oximeter (FS20F)" />)
  }

  const get_tensiometer_desc = () => {
    return(<FormattedMessage id="device.tensiometer.desc" defaultMessage="(BP2A, BPB6)" />)
  }

  const get_thermometer_desc = () => {
    return(<FormattedMessage id="device.thermometer.desc" defaultMessage="Connected thermometer (AOJ-20A)" />)
  }

  const get_scale_desc = () => {
    return(<FormattedMessage id="device.scale.desc" defaultMessage="(Lescale Lite, Lescale S5)" />)
  }

  const get_pain_desc = () => {
    return(<FormattedMessage id="device.pain.desc" defaultMessage="Pain scale (NRS)" />)
  }

  const get_healthform_desc = () => {
    return(<FormattedMessage id="device.healthform.desc" defaultMessage="Healthform" />)
  }

  const get_niv_desc = () => {
    return(<FormattedMessage id="device.niv.desc" defaultMessage="Respiratory devices" />)
  }

  const get_oxigentherapy_desc = () => {
    return(<FormattedMessage id="device.oxigentherapy.desc" defaultMessage="Respiratory devices" />)
  }

  const handleClickTucky = (event) => {
    setDisplayDeviceType("Tucky")
  }

  const handleClickTuckySmartphone = (event) => {
    setDisplayDeviceType("Tucky_smartphone")
    setDeviceIdValid(true)
  }

  const handleClickOximeter = (event) => {
    setDisplayDeviceType("Oximeter")
  }

  const handleClickTensiometer = (event) => {
    setDisplayDeviceType("Tensiometer")
  }

  const handleClickThermometer = (event) => {
    setDisplayDeviceType("Thermometer")
  }

  const handleClickScale = (event) => {
    setDisplayDeviceType("Scale")
  }

  const handleClickPain = (event) => {
    setDisplayDeviceType("pain")
    setDeviceIdValid(true)
  }

  const handleClickHealthform = (event) => {
    setDisplayDeviceType("healthform")
    setDeviceIdValid(true)
  }

  const handleClickNiv = (event) => {
    setDisplayDeviceType("niv")
    setDeviceIdValid(true)
  }

  const handleClickOxigentherapy = (event) => {
    setDisplayDeviceType("oxigen_therapy")
    setDeviceIdValid(true)
  }

  const handleDisplayTuckyParams = event => {
    if(event.target.value === "dissociate"){
      props.setDisplayTuckyParams(false);
      setDeviceIdValid(false)
    }
    else{
      props.setDisplayTuckyParams(true);
      setDeviceIdValid(true)
    }
  }

  const handleDisplayOximeterParams = event => {
    if(event.target.value === "dissociate"){
      props.setDisplayOximeterParams(false);
      setDeviceIdValid(false)
    }
    else{
      props.setDisplayOximeterParams(true);
      setDeviceIdValid(true)
    }
  }

  const handleDisplayTensiometerParams = event => {
    if(event.target.value === "dissociate"){
      props.setDisplayTensiometerParams(false);
      setDeviceIdValid(false)
    }
    else{
      props.setDisplayTensiometerParams(true);
      setDeviceIdValid(true)
    }
  }

  const handleDisplayScaleParams = event => {
    if(event.target.value === "dissociate"){
      props.setDisplayScaleParams(false);
      setDeviceIdValid(false)
    }
    else{
      props.setDisplayScaleParams(true);
      setDeviceIdValid(true)
    }
  }

  const handleDisplayThermometerParams = event => {
    if(event.target.value === "dissociate"){
      //props.setDisplayTensiometerParams(false);
      setDeviceIdValid(false)
    }
    else{
      //props.setDisplayTensiometerParams(true);
      setDeviceIdValid(true)
    }
  }

  const handleChangeFeverCheck = nextChecked => {
    setCheckedFever(nextChecked);
    props.setCheckedFever(nextChecked);
  };

  const handleChangeFeverThreshold = nextChecked => {
    setFeverThreshold(nextChecked);
    props.setFeverThreshold(nextChecked);
  };

  const handleChangePosition = nextChecked => {
    setPosition(nextChecked.target.value);
    props.setPosition(nextChecked.target.value);
  };

  const handleChangeDetachCheck = nextChecked => {
    setCheckedDetach(nextChecked);
    props.setCheckedDetach(nextChecked);
  };

  const handleChangeBatteryCheck = nextChecked => {
    setCheckedBattery(nextChecked);
    props.setCheckedBattery(nextChecked);
  };

  const handleChangePRTensionCheck = nextChecked => {
    setCheckedPRTension(nextChecked);
    props.setCheckedPRTension(nextChecked);
  };

  const handleChangeSystolicHighChecked = nextChecked => {
    setCheckedSystolicHigh(nextChecked);
    props.setCheckedSystolicHigh(nextChecked);
  };

  const handleChangeSPO2Check = nextChecked => {
    setCheckedSPO2(nextChecked);
    props.setCheckedSPO2(nextChecked);
  };

  const handleChangePRCheck = nextChecked => {
    setCheckedPR(nextChecked);
    props.setCheckedPR(nextChecked);
  };

const handleChangeWeightCheck = nextChecked => {
    setCheckedWeight(nextChecked);
    props.setCheckedWeight(nextChecked);
  };

  //Function to update patient,
  const checkParametersUpdate = () => {
    let component
    if (displayDeviceType === "Tucky" || displayDeviceType === "Tucky_smartphone") {
      if (document.getElementById("device1_add") !== null) {
      component = document.getElementById("device1_add").value;
      }
      else {
        component = "smartphone"
      }
      if (props.checkedFever) {
        let fever_alert = props.profileData.Patient_Data.alerts.fever_alert
        let fever_threshold = document.getElementById("fever_alert_threshold").value;
        let fever_delay_input = document.getElementById("fever_alert_delay");
        let fever_threshold2_input = document.getElementById("fever_alert_threshold2")
        let fever_threshold2;
        if (fever_threshold2_input !== null) {
          fever_threshold2 = fever_threshold2_input.value;
          fever_alert.threshold2 = fever_threshold2
          fever_alert.sup_or_inf2 = "inf";
        }

        fever_alert.threshold = fever_threshold
        if (fever_delay_input !== null) {
          fever_alert.delay = fever_delay_input.value
        }
        props.setFeverAlert(fever_alert)
      }
      if (component === "smartphone") {
        let new_module_activation = props.moduleActivation
        new_module_activation[new_module_activation.findIndex((module) => module.name === "tucky_smartphone")].used = true
        props.setModuleActivation(new_module_activation)
        props.setDisplayAlertModes("smartphone")
        props.setSmartphoneVisible(true)
      }
      else {
      let sensor = (props.device_list.find(device => device.id_device === component)||{id: "dissociate", id_old: "", type: "", nickname: "--", sn: ""});
      //to deal with the change from thermometer to Tucky in one request:
      let id_old = props.selectedDeviceList.device1.id
      if (props.selectedDeviceList.device1.id === "dissociate") {
        id_old = props.selectedDeviceList.device1.id_old
      }
      let new_device = {
        id_old: id_old,
        id: sensor.id_device,
        type: sensor.type,
        nickname: sensor.nickname,
        sn: sensor.sn
      }
      let new_list = props.selectedDeviceList
      new_list.device1 = new_device
      props.setSelectedDeviceList(new_list)
        props.setDevicesVisible(true)
      }
    }
    else if (displayDeviceType === "Oximeter") {
      component = document.getElementById("device2_add").value;
      if (props.checkedPR) {
        let PRAlert = props.profileData.Patient_Data.alerts.PR_alert
        let PRThreshold = document.getElementById("pulseRateAlert_threshold").value
        let PRDelay_input = document.getElementById("pulseRateAlert_delay")
        let PRThreshold2_input = document.getElementById("pulseRateAlert_threshold2")
        let PRThreshold2;
        if (PRThreshold2_input !== null) {
          PRThreshold2 = PRThreshold2_input.value;
          PRAlert.threshold2 = PRThreshold2
          PRAlert.sup_or_inf2 = "inf";
        }

        PRAlert.threshold = PRThreshold
        if (PRDelay_input !== null) {
          PRAlert.delay = PRDelay_input.value
        }
        props.setPRAlert(PRAlert)
      }
      if (props.checkedSPO2) {
        let SPO2Alert = props.profileData.Patient_Data.alerts.SPO2_alert
        let SPO2Threshold = document.getElementById("spo2_threshold").value
        let SPO2Delay_input = document.getElementById("spo2_delay")
        let SPO2Threshold2_input = document.getElementById("spo2_threshold2")
        let SPO2Threshold2;
        if (SPO2Threshold2_input !== null) {
          SPO2Threshold2 = SPO2Threshold2_input.value;
          SPO2Alert.threshold2 = SPO2Threshold2
          SPO2Alert.sup_or_inf2 = "sup";
        }

        SPO2Alert.threshold = SPO2Threshold
        if (SPO2Delay_input !== null) {
          SPO2Alert.delay = SPO2Delay_input.value
        }
        props.setSPO2Alert(SPO2Alert)
      }
      let sensor = (props.device_list.find(device => device.id_device === component)||{id: "dissociate", id_old: "", type: "", nickname: "--", sn: ""});
      let new_device = {
        id_old: props.selectedDeviceList.device2.id,
        id: sensor.id_device,
        type: sensor.type,
        nickname: sensor.nickname,
        sn: sensor.sn
      }
      let new_list = props.selectedDeviceList
      new_list.device2 = new_device
      props.setSelectedDeviceList(new_list)
      props.setDevicesVisible(true)
    }
    else if (displayDeviceType === "Tensiometer") {
      component = document.getElementById("device3_add").value;
      if (props.checkedPRTension) {
        let PRTensionAlert = props.profileData.Patient_Data.alerts.bloodpressure_PR_alert
        let PRTensionThreshold = document.getElementById("pulseRateAlertTension_threshold").value
        let PRTensionDelay_input = document.getElementById("pulseRateAlertTension_delay")
        let PRTensionThreshold2_input = document.getElementById("pulseRateAlertTension_threshold2")
        let PRTensionThreshold2;
        if (PRTensionThreshold2_input !== null) {
          PRTensionThreshold2 = PRTensionThreshold2_input.value;
          PRTensionAlert.threshold2 = PRTensionThreshold2
          PRTensionAlert.sup_or_inf2 = "inf";
        }

        PRTensionAlert.threshold = PRTensionThreshold
        if (PRTensionDelay_input !== null) {
          PRTensionAlert.delay = PRTensionDelay_input.value
        }
        props.setPRTensionAlert(PRTensionAlert)
      }
      if (props.checkedSystolicHigh) {
        let systolicHighAlert = props.profileData.Patient_Data.alerts.bloodpressure_sys_high_alert
        let systolicHighThreshold = document.getElementById("systolicHighAlert_threshold").value
        let systolicHighDelay_input = document.getElementById("systolicHighAlert_delay")
        let systolicHighThreshold2_input = document.getElementById("systolicHighAlert_threshold2")
        let systolicHighThreshold2;
        if (systolicHighThreshold2_input !== null) {
          systolicHighThreshold2 = systolicHighThreshold2_input.value;
        }

        systolicHighAlert.threshold = systolicHighThreshold
        systolicHighAlert.threshold2 = systolicHighThreshold2
        systolicHighAlert.sup_or_inf2 = "inf";
        if (systolicHighDelay_input !== null) {
          systolicHighAlert.delay = systolicHighDelay_input.value
        }
        props.setSystolicHighAlert(systolicHighAlert)
      }
      if (props.checkedDiastolicHigh) {
        let diastolicHighAlert = props.profileData.Patient_Data.alerts.bloodpressure_dia_alert
        let diastolicHighThreshold = document.getElementById("diastolicHighAlert_threshold").value
        let diastolicHighDelay_input = document.getElementById("diastolicHighAlert_delay")
        let diastolicHighThreshold2_input = document.getElementById("diastolicHighAlert_threshold2")
        let diastolicHighThreshold2;
        if (diastolicHighThreshold2_input !== null) {
          diastolicHighThreshold2 = diastolicHighThreshold2_input.value;
        }

        diastolicHighAlert.threshold = diastolicHighThreshold
        diastolicHighAlert.threshold2 = diastolicHighThreshold2
        diastolicHighAlert.sup_or_inf2 = "inf";
        if (diastolicHighDelay_input !== null) {
          diastolicHighAlert.delay = diastolicHighDelay_input.value
        }
        props.setDiastolicHighAlert(diastolicHighAlert)
      }
      let sensor = (props.device_list.find(device => device.id_device === component)||{id: "dissociate", id_old: "", type: "", nickname: "--", sn: ""});
      let new_device = {
        id_old: props.selectedDeviceList.device3.id,
        id: sensor.id_device,
        type: sensor.type,
        nickname: sensor.nickname,
        sn: sensor.sn
      }
      let new_list = props.selectedDeviceList
      new_list.device3 = new_device
      props.setSelectedDeviceList(new_list)
      props.setDevicesVisible(true)
    }
    else if (displayDeviceType === "Thermometer") {
      component = document.getElementById("device1_add").value;
      let fever_alert = props.profileData.Patient_Data.alerts.fever_alert
      if (props.checkedFever) {
        let fever_threshold = document.getElementById("fever_alert_threshold").value;
        let fever_delay_input = document.getElementById("fever_alert_delay");
        let fever_threshold2_input = document.getElementById("fever_alert_threshold2")
        let fever_threshold2;
        if (fever_threshold2_input !== null) {
          fever_threshold2 = fever_threshold2_input.value;
          fever_alert.threshold2 = fever_threshold2
          fever_alert.sup_or_inf2 = "inf";
        }

        fever_alert.threshold = fever_threshold
        if (fever_delay_input !== null) {
          fever_alert.delay = fever_delay_input.value
        }
      }
      props.setFeverAlert(fever_alert)
      props.setPosition("0")
      props.setCheckedDetach(false)
      props.setCheckedBattery(false)
      let sensor = (props.device_list.find(device => device.id_device === component)||{id: "dissociate", id_old: "", type: "", nickname: "--", sn: ""});
      //to deal with the change from Tucky to thermometer in one request:
      let id_old = props.selectedDeviceList.device1.id
      if (props.selectedDeviceList.device1.id === "dissociate") {
        id_old = props.selectedDeviceList.device1.id_old
      }
      let new_device = {
        id_old: id_old,
        id: sensor.id_device,
        type: sensor.type,
        nickname: sensor.nickname,
        sn: sensor.sn
      }
      let new_list = props.selectedDeviceList
      new_list.device1 = new_device
      props.setSelectedDeviceList(new_list)
      props.setDevicesVisible(true)
    }
    else if (displayDeviceType === "Scale") {
      component = document.getElementById("device4_add").value;
      let Local_weight_alert = props.profileData.Patient_Data.alerts.weight_alert
      if (props.checkedWeight) {
        Local_weight_alert.threshold = document.getElementById("weight_threshold").value;
        let weight_delay_input = document.getElementById("weight_delay");
        if (weight_delay_input !== null) {
          Local_weight_alert.delay = weight_delay_input.value;
        }
        let weight_threshold2_input = document.getElementById("weight_threshold2")
        if (weight_threshold2_input !== null) {
          Local_weight_alert.threshold2 = weight_threshold2_input.value;
          Local_weight_alert.sup_or_inf2 = "inf";
        }
      }
      props.setWeightAlert(Local_weight_alert)

      let sensor = (props.device_list.find(device => device.id_device === component)||{id: "dissociate", id_old: "", type: "", nickname: "--", sn: ""});
      let new_device = {
        id_old: props.selectedDeviceList.device4.id,
        id: sensor.id_device,
        type: sensor.type,
        nickname: sensor.nickname,
        sn: sensor.sn
      }
      let new_list = props.selectedDeviceList
      new_list.device4 = new_device
      props.setSelectedDeviceList(new_list)
      props.setDevicesVisible(true)
    }
    else if (displayDeviceType === "healthform") {
      let Local_healthform_alert
      let isHealthformChecked
      let Local_healthscale_alert
      let isHealthscaleChecked
      switch(selectedHealthformType) {
        case "EQ5D":
          Local_healthform_alert = props.profileData.Patient_Data.alerts.eq5d_alert
          Local_healthscale_alert = props.profileData.Patient_Data.alerts.eq5d_scale_alert
          isHealthformChecked = props.checkedEQ5D
          isHealthscaleChecked = props.checkedEQ5D
          break
        case "SF36":
          Local_healthform_alert = props.profileData.Patient_Data.alerts.sf36_alert
          isHealthformChecked = props.checkedSF36
          break
        case "MDASI":
          Local_healthform_alert = props.profileData.Patient_Data.alerts.mdasi_alert
          isHealthformChecked = props.checkedMDASI
          break
      }
      if (isHealthformChecked) {
        Local_healthform_alert.threshold = document.getElementById("healthformAlert_threshold").value;
        let healthform_delay_input = document.getElementById("healthformAlert_delay");
        if (healthform_delay_input !== null) {
          Local_healthform_alert.delay = healthform_delay_input.value;
        }
      }
      if (isHealthscaleChecked) {
        Local_healthscale_alert.threshold = document.getElementById("healthformScaleAlert_threshold").value;
        let healthscale_delay_input = document.getElementById("healthformScaleAlert_delay");
        if (healthscale_delay_input !== null) {
          Local_healthscale_alert.delay = healthscale_delay_input.value;
        }
      }
      let new_module_activation = props.moduleActivation
      new_module_activation[new_module_activation.findIndex((module) => module.name === selectedHealthformType)].used = true
      props.setModuleActivation(new_module_activation)
      props.setHealthformsVisible(true)
    }
    else if (displayDeviceType === "pain") {
      let Local_pain_alert
      let isPainChecked
      Local_pain_alert = props.profileData.Patient_Data.alerts.eq5d_alert
      isPainChecked = props.checkedPain
      if (isPainChecked) {
        Local_pain_alert.threshold = document.getElementById("pain_threshold").value;
        let pain_delay_input = document.getElementById("pain_delay");
        if (pain_delay_input !== null) {
          Local_pain_alert.delay = pain_delay_input.value;
        }
      }
      let new_module_activation = props.moduleActivation
      new_module_activation[new_module_activation.findIndex((module) => module.name === "pain")].used = true
      props.setModuleActivation(new_module_activation)
      props.setHealthformsVisible(true)
    }
    else if (displayDeviceType === "niv") {
      let new_module_activation = props.moduleActivation
      new_module_activation[new_module_activation.findIndex((module) => module.name === "niv")].used = true
      props.setModuleActivation(new_module_activation)
      props.setModulesVisible(true)
    }
    else if (displayDeviceType === "oxigen_therapy") {
      let new_module_activation = props.moduleActivation
      new_module_activation[new_module_activation.findIndex((module) => module.name === "oxigen_therapy")].used = true
      props.setModuleActivation(new_module_activation)
      props.setModulesVisible(true)
    }
    props.setChangeOngoing(true)
    props.cancelPopup()
  };

  // ###### RENDER FUNCTIONS ######
  const { classes } = props;

  const { Meta } = Card;


  //Function to render input components
  const renderInput = (type, nameID, defaultValue, min, max, step, precision) => {
    if(type === "text"){
      return(<input type={type} id={nameID} name={nameID} defaultValue={defaultValue} style={{width: "100%", border: "1px solid gray"}}/>)
    }
    else if(type === "number"){
      return(<input type="number" id={nameID} name={nameID} min={min} max={max} step={step} precision={precision} defaultValue={defaultValue} style={{width: "100%", border: "1px solid gray"}}/>)
    }
    else{
      return null;
    }
  }

  //Function to render switch elements
  const renderSwitch = (ID, handleChange, checked) => {
    return(
      <Switch
        id={ID}
        onChange={handleChange}
        checked={checked}
        className="react-switch"
        height = {20}
        width = {46}
      />
    );
  }

  const renderSelect = (nameID, list, defaultValue, handleChange, deviceType) => {
    if((nameID === "device1_add")||(nameID==="device2_add")||(nameID==="device3_add")||(nameID==="device4_add")){
      if (list[0] === undefined || list[0].id_device !== "dissociate") {
        list.unshift({ 'id_device':"dissociate", 'sn':"dissociate", 'nickname': '--', 'fullname':noAssociationMsg, 'type': 'none' });
      }
      return(
        <select id={nameID} name={nameID} defaultValue={defaultValue} style={{width: "100%", border: "1px solid gray", marginBottom:"1%"}} onChange={handleChange}>
          {
            list.map((device,index)=> {
              let fullname
              if (device.sn !== "dissociate") {
                fullname = device.nickname + " (" + device.sn + ")"
              }
              else {
                fullname = device.nickname
              }
              if((device.type === deviceType)||(device.type === 'none')){
                return (<option value={device.id_device} key={index}>{fullname}</option>);
              }
              else{
                return (null);
              }
            })
          }
        </select>
      )
    }

    //Case position select
    else if(nameID === "position"){
      return(
        <select id={nameID} name={nameID} defaultValue={defaultValue} onChange={handleChangePosition} style={{width: "100%", border: "1px solid gray", marginBottom:"1%"}}>
          <FormattedMessage id="param.deactivated" key={"0"} defaultMessage="Deactivated">
             {(message) => <option value={"0"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.standupPosition" key={"1"} defaultMessage="At standing up">
             {(message) => <option value={"1"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.backPosition" key={"2"} defaultMessage="Dorsal decubitus">
             {(message) => <option value={"2"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.bellyPosition" key={"4"} defaultMessage="Ventral decubitus">
             {(message) => <option value={"4"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.sidePosition" key={"24"} defaultMessage="Lateral decubitus">
             {(message) => <option value={"24"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.allPosition" key={"31"} defaultMessage="At all position changes">
             {(message) => <option value={"31"}>{message}</option>}
          </FormattedMessage>
        </select>
      )
    }

    else{
      return null;
    }
  }

  const addThreshold = (alert) => {
    let updated_device = newDevice
    updated_device.sup_or_inf2 = "inf"
    setNewDevice(updated_device)
    let saved_device_type = displayDeviceType
    props.setRerender(!props.rerender)
  }

  const deleteThreshold = (alert) => {
    let updated_device = newDevice
    delete updated_device.sup_or_inf2
    setNewDevice(updated_device)
    let saved_device_type = displayDeviceType
    props.setRerender(!props.rerender)
  }

  //Function to return row with threshold and delay params
  const renderAlertThresholdAndDelayRow = (titleID, defaultTitle, alertName, handleSwitchChange, isChecked, alertParams) => {
    if (JSON.stringify(newDevice) === "{}") {
      setNewDevice(alertParams)
    }
    alertParams = newDevice
    let unit = Utils.convertTextToFormattedMessageIdUnits(alertParams.type)
    return(
      <Row>
        <Row style={{width:"100%"}}>
          <Col style={{width:"14%", textAlign:"left"}}>
            <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
          </Col>
          <Col style={{width:"16%"}}>
            {renderSwitch(alertName, handleSwitchChange, isChecked)}
          </Col>
          {isChecked ?
            <Col style={{width:"70%"}}>
              <Row>
                <Col style={{width:"6%"}}>
                  {alertParams.sup_or_inf === "sup" ?
                    <Icon name='chevron right' size='small' style={{margin:"0px"}}/>
                    :
                    <Icon name='chevron left' size='small' style={{margin:"0px"}}/>
                  }
                </Col>
                <Col style={{width:"32%", textAlign:"left", paddingRight:"0%"}}>
                  {renderInput("number", alertName + "_threshold_add", alertParams.threshold.defaut, alertParams.threshold.min, alertParams.threshold.max, alertParams.threshold.step, alertParams.threshold.precision)}
                </Col>
                <Col style={{maxWidth:"20%"}}>
                  <FormattedMessage id={unit.id} defaultMessage={unit.defaultMessage} />
                </Col>
                <Col style={{width:"18%"}}>
                  <FormattedMessage id="param.delay" defaultMessage="Delay"/>
                </Col>
                <Col style={{width:"22%", textAlign:"left", paddingRight:"0px"}}>
                  {renderInput("number", alertName + "_delay_add", alertParams.delay.defaut, alertParams.delay.min, alertParams.delay.max, alertParams.delay.step, alertParams.delay.precision)}
                </Col>
              </Row>
            </Col>
            :
            null
          }
        </Row>
        {(alertParams.sup_or_inf2 === undefined || alertParams.threshold2 === undefined) ?
          <Row style={{width:"100%"}}>
            <Col style={{width:"14%"}}>
            </Col>
            <Col style={{width:"16%"}}>
            </Col>
            <Col style={{width:"70%"}}>
              {isChecked ?
                <Row>
                  <Col style={{width:"6%"}}>
                  </Col>
                  <Col>
                    <Icon name='plus' size='small' color='green' style={{margin:"0px", padding:0}} onClick={(e) => addThreshold(alertParams)}/>
                  </Col>
                </Row>
                :
                null
              }
            </Col>
          </Row>
          :
          <Row style={{width:"100%"}}>
            <Col style={{width:"14%"}}>
            </Col>
            <Col style={{width:"16%"}}>
            </Col>
            {isChecked ?
              <Col style={{width:"70%"}}>
                <Row>
                  <Col style={{width:"6%"}}>
                  {alertParams.sup_or_inf2 === "sup" ?
                    <Icon name='chevron right' size='small' style={{margin:"0px"}}/>
                    :
                    <Icon name='chevron left' size='small' style={{margin:"0px"}}/>
                  }
                  </Col>
                  <Col style={{width:"32%", paddingRight:"0px"}}>
                    {renderInput("number", alertName + "_threshold2_add", alertParams.threshold2.defaut, alertParams.threshold2.min, alertParams.threshold2.max, alertParams.threshold2.step, alertParams.threshold2.precision)}
                  </Col>
                  <Col style={{maxWidth:"20%"}}>
                    <FormattedMessage id={unit.id} defaultMessage={unit.defaultMessage} />
                  </Col>
                  <Col style={{width:"18%", textAlign:"left"}}>
                    <Icon name='minus' size='small' color='red' style={{margin:"0px", paddingLeft:10}} onClick={(e) => deleteThreshold(alertParams)}/>
                  </Col>
                  <Col style={{width:"22%"}}>
                  </Col>
                </Row>
              </Col>
              :
              null
            }
          </Row>
        }
      </Row>
    );
  }

  //Function to return row with only select element
  const renderAlertSelectRow = (titleID, defaultTitle) => {
    return(
      <Row>
        <Col style={{maxWidth:"30%"}}>
          <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
        </Col>
        <Col style={{maxWidth:"70%"}}>
          {renderSelect("position", [], props.profileData.Patient_Data.alerts.pos_alert.threshold, "", "")}
        </Col>
      </Row>
    );
  }

  //Function to return row with only switch element
  const renderAlertSwitchRow = (titleID, defaultTitle, alertType, handleChange, checked) => {
    return(
      <Row>
        <Col style={{maxWidth:"40%"}}>
          <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
        </Col>
        <Col style={{maxWidth:"60%"}}>
          {renderSwitch(alertType, handleChange, checked)}
        </Col>
      </Row>
    );
  }

  //Function to return row with threshold and delay params
  const renderReminderRow = (titleID, defaultTitle, alertName, handleSwitchChange, isChecked, type) => {
    let hours_number = 0
    let input_value = 2
    return(
      <div>
        <Row width="100%">
          <Tooltip style={{ zIndex: 99 }}id="tooltip-reminder-adddevice">
              {props.select_tooltip("param.reminderMode.tooltip")}
          </Tooltip>
          <Col style={{width:"14%", textAlign:"left"}} data-tooltip-id="tooltip-reminder-adddevice" data-tooltip-place="bottom">
            <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
          </Col>
          <Col style={{width:"16%"}}>
            {renderSwitch(alertName, handleSwitchChange, isChecked)}
          </Col>
          {isChecked ?
            <Col style={{width:"70%"}}>
            {
              props.reminder_list.find(function(element){return(element.alert_type===type)}).alert_hours.split(",").map((obj,index)=> {
                let key = "reminder_time_margin_"+index
                if (props.reminder_list.find(function(element){return(element.alert_type===type)}).alert_hours !== "" && props.reminder_list.find(function(element){return(element.alert_type===type)}).alert_hours !== "--:--") {
                  hours_number = props.reminder_list.find(function(element){return(element.alert_type===type)}).alert_hours.split(",").length
                  input_value = props.reminder_list.find(function(element){return(element.alert_type===type)}).margin
                }
                return <Row style={{width:"100%"}}>
                  {index === 0 ?
                    <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px", width:"19%"}}>
                      <FormattedMessage id="param.reminderActivatedHours" defaultMessage="Time"/>
                    </Col>
                    :
                    <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px", width:"19%"}}>
                    </Col>
                  }
                  {index === 0 ?
                    <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"20px", width:"32%"}}>
                      <input type="time" id="start_hour" key="0" name="{props.profileData.Patient_Data.alerts.reminder_alert}" value={obj} style={{border: "1px solid gray"}} onChange={event => props.handleChangeReminderHours(event.target.value, index, type)}/>
                    </Col>
                    :
                    <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"20px", width:"32%"}}>
                      <input type="time" id="start_hour" key={key} name="{props.profileData.Patient_Data.alerts.reminder_alert}" value={obj} style={{border: "1px solid gray"}} onChange={event => props.handleChangeReminderHours(event.target.value, index, type)}/>
                    </Col>
                  }
                  {index === 0 ?
                    <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px", width:"20%"}}>
                      <FormattedMessage id="popup.reminder.time_margin" defaultMessage="+/-(h)"/>
                    </Col>
                    :
                    <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px", width:"20%"}}>
                      <button onClick={() => props.deleteHours(index, type)} style={{ padding:0, border:"0px", backgroundColor:"white"}}>
                        <Icon name='minus' size='small' color='red' style={{margin:"0px"}}/>
                      </button>
                    </Col>
                  }
                  {index === 0 ?
                    <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px", width:"26%"}}>
                      <input type="number" id={type+"_frequency"} name={type+"_frequency"} value={input_value} defaultValue={2} min={1} max={1000} step={1} precision={1} style={{border: "1px solid gray", width: "100%"}} onChange={() => props.handleChangeReminderFrequency(event, type)}/>
                    </Col>
                    :
                    <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px", width:"26%"}}>
                    </Col>
                  }
                </Row>
              })
            }
            </Col>
            :
            null
          }
        </Row>
        {isChecked ?
          <Row width="100%">
            <Col style={{width:"30%"}}>
            </Col>
            <Col style={{width:"70%"}}>
              <Row style={{width:"100%"}}>
                <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px", width:"19%"}}>
                </Col>
                <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"20px", width:"32%"}}>
                  {props.testHoursDisabled(hours_number) ?
                    null
                    :
                    <button onClick={() => props.addNewHours(props.getNewReminderHour(type), type)} style={{ padding:0, border:"0px", backgroundColor:"white"}}>
                      <Icon id="id" name='add' size='small' color='green' style={{margin:"0px"}} class/>
                    </button>
                  }
                </Col>
                <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px", width:"20%"}}>
                </Col>
                <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px", width:"26%"}}>
                </Col>
              </Row>
            </Col>
          </Row>
          :
          null
        }
      </div>
    )
  }

  const renderReminderForm = (type) => {
    let reminder_activated = Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("reminder"))
    if (reminder_activated === true) {    
      return(
        <div>
          {renderReminderRow("param.reminderMode", "Reminder", type, props.findSetCheckedReminder(type), props.findCheckedReminder(type), type)}
        </div>
      );
    }
    else {
      return (null)
    }
  }

  const filterTuckyAOJ20 = (list, filtered_type) => {
    let list_ret = []
    list.forEach(device => {
      if (
          (device.sn.includes('-') === false && filtered_type === "Tucky") ||
          (device.sn.includes('-') === true && filtered_type === "AOJ-20") ||
          (device.id_device === "dissociate")
         )
         {
        list_ret.push(device)
      }
    })
    return list_ret
  }

  const get_device_in_list_by_type = (type) => {
    let ret = false
    if (props.profileData.Patient_Data.devices.device1.type === type) {
      ret = props.profileData.Patient_Data.devices.device1
    }
    else if (props.profileData.Patient_Data.devices.device2.type === type) {
      ret = props.profileData.Patient_Data.devices.device2
    }
    else if (props.profileData.Patient_Data.devices.device3.type === type) {
      ret = props.profileData.Patient_Data.devices.device3
    }
    else if (props.profileData.Patient_Data.devices.device4.type === type) {
      ret = props.profileData.Patient_Data.devices.device4
    }    
    return ret
  }

  const get_device_in_list_by_type_and_usage = (type) => {
    let ret = false
    if (type.endsWith("_reminder")) {
      let find_reminder = props.reminder_list.find((reminder_list) => reminder_list.alert_type === type)
      if (find_reminder === undefined) {
        return false
      }
    }
    else if (type === "healthform") {
      ret = true
      let i = 0
      while (ret === true && props.moduleActivation[i]) {
        if ( ( props.moduleActivation[i].name === "EQ5D"
            || props.moduleActivation[i].name === "SF36"
            || props.moduleActivation[i].name === "MDASI"
            || props.moduleActivation[i].name === "alimentation"
          ) 
          &&
            props.moduleActivation[i].used === false) {
          ret = false
        }
        i++
      }
    }
    else if (type === "pain" || type === "niv" || type === "oxigen_therapy") {
      ret = true
      let i = 0
      while (ret === true && props.moduleActivation[i]) {
        if (props.moduleActivation[i].name === type && props.moduleActivation[i].used === false) {
          ret = false
        }
        i++
      }
    }
    else {
      let find = props.device_list.find((type_list) => type_list.type === type)
      if (find === undefined) {
        return true
      }
      if (type === "Tucky") {
        let module = props.moduleActivation.find((module) => module.name === "tucky_smartphone")
        if (props.selectedDeviceList.device1.id !== "dissociate") {
        ret = props.selectedDeviceList.device1
      }
        else if (module !== undefined && module.used === true) {
          ret = true
        }
      }
      else if (type === "FS20F" && props.selectedDeviceList.device2.id !== "dissociate") {
        ret = props.selectedDeviceList.device2
      }
      else if ((type === "BP2A" || type === "BPB6") && props.selectedDeviceList.device3.id !== "dissociate") {
        ret = props.selectedDeviceList.device3
      }
      else if ((type === "LESCALE" || type === "S5") && props.selectedDeviceList.device4.id !== "dissociate") {
        ret = props.selectedDeviceList.device4
      }
    }
    return ret
  }

  const renderButtons = () => {
    return (
      <div>
        <button onClick={props.cancelPopup} className="btn btn-danger">
          <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
        </button>
        {displayDeviceType !== "" ?
          <button onClick={checkParametersUpdate} className="btn btn-success" disabled={!deviceIdValid}>
            <FormattedMessage id="button.submit" defaultMessage="Submit" />
          </button>
          :
          null
        }
      </div>
    )
  }

  const testThermometerType = () => {
    return (displayDeviceType !== "Tucky" && displayDeviceType !== "Tucky_smartphone")
  }

let this_fever_alert = props.alert_filling("fever_alert")
let this_PR_alert = props.alert_filling("FS20F")
let this_spo2_alert = props.alert_filling("SPO2")
let this_PR_tension_alert = props.alert_filling("bloodpressure_PR_alert")
let this_sys_high_alert = props.alert_filling("bloodpressure_sys_high_alert")
let this_dia_alert = props.alert_filling("bloodpressure_dia_alert")
let this_weight_alert = props.alert_filling("LESCALE")
let this_eq5d_alert = props.alert_filling("eq5d")
let this_eq5d_scale_alert = props.alert_filling("eq5d_scale")
let this_sf36_alert = props.alert_filling("sf36")
let this_mdasi_alert = props.alert_filling("mdasi")
let this_pain_alert = props.alert_filling("pain")
let this_breathing_alert = props.alert_filling("breathing")
let this_breathing_oxygen_rate_alert = props.alert_filling("breathing_oxygen_rate")
let this_breathing_leakage_alert = props.alert_filling("breathing_leakage")
let this_breathing_leakage95_alert = props.alert_filling("breathing_leakage95")
let this_breathing_ahi_alert = props.alert_filling("breathing_ahi")
let this_breathing_observance_alert = props.alert_filling("breathing_observance")
  return (
    <div className={classes.popup_background}>
      <div style={{ minWidth:"100%", height: "100%", display: "flex", flexDirection: "column"}}>
        <div className="submit-form" style={{ minWidth:"400px",borderRadius: "5px"}}>
          {displayDeviceType === "" ?
            <div>
              {props.subscription_info.features === undefined 
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("thermometer")) 
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("oximeter")) 
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("niv")) 
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy"))
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("tensiometer"))
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("scale"))
              ?
              <Row className="justify-content-md-center">
                <Col style={{ fontWeight: "bold", fontSize:"2.2em", minWidth:"100%", textAlign: "center"}}>
                  <FormattedMessage id="home.sensors" defaultMessage="Devices" />
                </Col>
              </Row>
                :
                null
              }
              <Row className="justify-content-md-center">
                {props.subscription_info.features === undefined || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("thermometer")) ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: (get_device_in_list_by_type_and_usage("Tucky") !== false) ? 0.25 : 1}} onClick={(get_device_in_list_by_type_and_usage("Tucky") !== false) ? undefined : handleClickTucky}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_tucky} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_tucky_name()} description={get_tucky_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
                {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("oximeter")) || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("niv")) || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")) ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: (get_device_in_list_by_type_and_usage("FS20F") !== false) ? 0.25 : 1}} onClick={(get_device_in_list_by_type_and_usage("FS20F") !== false) ? undefined : handleClickOximeter}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_oximeter} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_oximeter_name()} description={get_oximeter_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
                {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("tensiometer")) ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: ((get_device_in_list_by_type_and_usage("BP2A") !== false) && (get_device_in_list_by_type_and_usage("BPB6") !== false)) ? 0.25 : 1}} onClick={((get_device_in_list_by_type_and_usage("BP2A") !== false) && (get_device_in_list_by_type_and_usage("BPB6") !== false)) ? undefined : handleClickTensiometer}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_tensiometer} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_tensiometer_name()} description={get_tensiometer_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
                {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("thermometer")) ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: (get_device_in_list_by_type_and_usage("Tucky") !== false) ? 0.25 : 1}} onClick={(get_device_in_list_by_type_and_usage("Tucky") !== false) ? undefined : handleClickThermometer}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_thermometer} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_thermometer_name()} description={get_thermometer_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
                {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("scale")) ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: ((get_device_in_list_by_type_and_usage("LESCALE") !== false) && (get_device_in_list_by_type_and_usage("S5") !== false)) ? 0.25 : 1}} onClick={((get_device_in_list_by_type_and_usage("LESCALE") !== false) && (get_device_in_list_by_type_and_usage("S5") !== false)) ? undefined : handleClickScale}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_scale} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_scale_name()} description={get_scale_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
              </Row>
              {props.subscription_info.features === undefined 
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("niv")) 
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy"))
              ?
              <Row className="justify-content-md-center">
                <Col style={{ fontWeight: "bold", fontSize:"2.2em", minWidth:"100%", textAlign: "center"}}>
                  <FormattedMessage id="devices.modules" defaultMessage="Modules" />
                </Col>
              </Row>
                :
                null
              }
              <Row className="justify-content-md-center">
                {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("niv")) ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: (get_device_in_list_by_type_and_usage("niv") !== false) ? 0.25 : 1}} onClick={(get_device_in_list_by_type_and_usage("niv") !== false) ? undefined : handleClickNiv}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_vni} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_niv_name()} description={get_niv_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
                {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")) ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: (get_device_in_list_by_type_and_usage("oxigen_therapy") !== false) ? 0.25 : 1}} onClick={(get_device_in_list_by_type_and_usage("oxigen_therapy") !== false) ? undefined : handleClickOxigentherapy}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_oxygentherapy} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_oxigentherapy_name()} description={get_oxigentherapy_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
              </Row>
              {props.subscription_info.features === undefined 
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("pain")) 
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D"))
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36"))
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI"))
              || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION"))
              ?
              <Row className="justify-content-md-center">
                <Col style={{ fontWeight: "bold", fontSize:"2.2em", minWidth:"100%", textAlign: "center"}}>
                  <FormattedMessage id="devices.healthforms" defaultMessage="Healthforms" />
                </Col>
              </Row>
                :
                null
              }
              <Row className="justify-content-md-center">
                {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("pain")) ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: (get_device_in_list_by_type_and_usage("pain") !== false) ? 0.25 : 1}} onClick={(get_device_in_list_by_type_and_usage("pain") !== false) ? undefined : handleClickPain}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_pain} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_pain_name()} description={get_pain_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
                {props.subscription_info.features === undefined 
                  || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D"))
                  || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36"))
                  || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI"))
                  || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION"))
                   ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: (get_device_in_list_by_type_and_usage("healthform") !== false) ? 0.25 : 1}} onClick={(get_device_in_list_by_type_and_usage("healthform") !== false) ? undefined : handleClickHealthform}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_healthform} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_healthform_name()} description={get_healthform_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
              </Row>
                {props.subscription_info.features === undefined 
                || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("thermometer"))
                 ?
              <Row className="justify-content-md-center">
                <Col style={{ fontWeight: "bold", fontSize:"2.2em", minWidth:"100%", textAlign: "center"}}>
                  <FormattedMessage id="param.SwitchMonitoringSmartphone" defaultMessage="Smartphone" />
                  </Col>
              </Row>
                :
                null
              }
              <Row className="justify-content-md-center">
                {props.subscription_info.features === undefined || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("thermometer")) ?
                  <Col style={{minWidth:"50%", maxWidth:"290px", marginBottom:"2%", width:"100%", opacity: (get_device_in_list_by_type_and_usage("Tucky") !== false) ? 0.25 : 1}} onClick={(get_device_in_list_by_type_and_usage("Tucky") !== false) ? undefined : handleClickTuckySmartphone}>
                    <Card
                      hoverable
                      style={{ height: "100%", marginBottom:"2%", marginLeft:"2px", marginRight:"2px", overflow: "hidden", borderRadius: "5px", borderColor: "black" }}
                      cover={<img alt="example" src={img_tucky} style={{ height: "auto", maxHeight: "128px", width: "auto", maxWidth: "128px"}}/>}
                    >
                      <Meta title={get_tucky_name()} description={get_tucky_desc()} />
                    </Card>
                  </Col>
                  :
                  null
                }
              </Row>
            </div>
          :
            null
          }
          {displayDeviceType === "Tucky" ?
            <DeviceForm
              type={displayDeviceType}
              origin={"creation"}
              get_device_name={props.get_device_name}
              device={{type: "Tucky", sn: ""}}
              device_list={props.device_list}
              selectedDeviceList={props.selectedDeviceList}
              this_fever_alert={this_fever_alert}
              deviceIdValid={deviceIdValid}
              filterTuckyAOJ20={filterTuckyAOJ20}
              testThermometerType={testThermometerType}
              checkParametersUpdate={checkParametersUpdate}
              cancelPopup={props.cancelPopup}
              handleChangeDeviceId={handleDisplayTuckyParams}
              handleChangeFeverCheck={props.handleChangeFeverCheck}
              handleChangeFeverThreshold={props.handleChangeFeverThreshold}
              handleChangeFeverThreshold2={props.handleChangeFeverThreshold2}
              handleChangeFeverDelay={props.handleChangeFeverDelay}
              handleChangeDetachCheck={props.handleChangeDetachCheck}
              handleChangeBatteryCheck={props.handleChangeBatteryCheck}
              checkedFever={props.checkedFever}
              checkedDetach={props.checkedDetach}
              checkedBattery={props.checkedBattery}
              renderDeviceSelectRow={props.renderDeviceSelectRow}
              renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
              renderAlertSelectRow={props.renderAlertSelectRow}
              renderAlertSwitchRow={props.renderAlertSwitchRow}
              renderReminderForm={props.renderReminderForm}
            />
            :
            null
          }
          {displayDeviceType === "Oximeter" ?
            <DeviceForm
              type={"FS20F"}
              origin={"creation"}
              features={props.subscription_info.features}
              get_device_name={props.get_device_name}
              device={{type: "FS20F", sn: ""}}
              device_list={props.device_list}
              selectedDeviceList={props.selectedDeviceList}
              this_PR_alert={this_PR_alert}
              this_spo2_alert={this_spo2_alert}
              deviceIdValid={deviceIdValid}
              checkParametersUpdate={checkParametersUpdate}
              cancelPopup={props.cancelPopup}
              handleChangeDeviceId={handleDisplayTuckyParams}
              handleChangePRCheck={props.handleChangePRCheck}
              handleChangePRThreshold={props.handleChangePRThreshold}
              handleChangePRThreshold2={props.handleChangePRThreshold2}
              handleChangePRDelay={props.handleChangePRDelay}
              handleChangeSPO2Check={props.handleChangeSPO2Check}
              handleChangeSPO2Threshold={props.handleChangeSPO2Threshold}
              handleChangeSPO2Delay={props.handleChangeSPO2Delay}
              handleChangeBatteryCheck={props.handleChangeBatteryCheck}
              checkedPR={props.checkedPR}
              checkedSPO2={props.checkedSPO2}
              renderDeviceSelectRow={props.renderDeviceSelectRow}
              renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
              renderAlertSelectRow={props.renderAlertSelectRow}
              renderAlertSwitchRow={props.renderAlertSwitchRow}
              renderReminderForm={props.renderReminderForm}
              renderReminderFormNoCheck={props.renderReminderFormNoCheck}
            />
          :
            null
          }
          {displayDeviceType === "Tensiometer" ?
            <DeviceForm
              type={"BP2A"}
              origin={"creation"}
              get_device_name={props.get_device_name}
              device={{type: "BP2A", sn: ""}}
              device_list={props.device_list}
              selectedDeviceList={props.selectedDeviceList}
              this_PR_tension_alert={this_PR_tension_alert}
              this_sys_high_alert={this_sys_high_alert}
              this_dia_alert={this_dia_alert}
              deviceIdValid={deviceIdValid}
              checkParametersUpdate={checkParametersUpdate}
              cancelPopup={props.cancelPopup}
              handleChangeDeviceId={handleDisplayTuckyParams}
              handleChangePRTensionCheck={props.handleChangePRTensionCheck}
              handleChangePRTensionThreshold={props.handleChangePRTensionThreshold}
              handleChangePRTensionThreshold2={props.handleChangePRTensionThreshold2}
              handleChangePRTensionDelay={props.handleChangePRTensionDelay}
              handleChangeSystolicHighChecked={props.handleChangeSystolicHighChecked}
              handleChangeSystolicHighThreshold={props.handleChangeSystolicHighThreshold}
              handleChangeSystolicHighThreshold2={props.handleChangeSystolicHighThreshold2}
              handleChangeSystolicHighDelay={props.handleChangeSystolicHighDelay}
              handleChangeDiastolicHighChecked={props.handleChangeDiastolicHighChecked}
              handleChangeDiastolicHighThreshold={props.handleChangeDiastolicHighThreshold}
              handleChangeDiastolicHighThreshold2={props.handleChangeDiastolicHighThreshold2}
              handleChangeDiastolicHighDelay={props.handleChangeDiastolicHighDelay}
              checkedPRTension={props.checkedPRTension}
              checkedSystolicHigh={props.checkedSystolicHigh}
              checkedDiastolicHigh={props.checkedDiastolicHigh}
              renderDeviceSelectRow={props.renderDeviceSelectRow}
              renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
              renderAlertSelectRow={props.renderAlertSelectRow}
              renderAlertSwitchRow={props.renderAlertSwitchRow}
              renderReminderForm={props.renderReminderForm}
            />
            :
            null
          }
          {displayDeviceType === "Thermometer" ?
            <div>
              <DeviceForm
                type={"AOJ-20"}
                origin={"creation"}
                get_device_name={props.get_device_name}
                device={{type: "Tucky", sn: "-"}}
                device_list={props.device_list}
                selectedDeviceList={props.selectedDeviceList}
                this_fever_alert={this_fever_alert}
                deviceIdValid={deviceIdValid}
                filterTuckyAOJ20={filterTuckyAOJ20}
                testThermometerType={testThermometerType}
                checkParametersUpdate={checkParametersUpdate}
                cancelPopup={props.cancelPopup}
                handleChangeDeviceId={handleDisplayTuckyParams}
                handleChangeFeverCheck={props.handleChangeFeverCheck}
                handleChangeFeverThreshold={props.handleChangeFeverThreshold}
                handleChangeFeverThreshold2={props.handleChangeFeverThreshold2}
                handleChangeFeverDelay={props.handleChangeFeverDelay}
                checkedFever={props.checkedFever}
                renderDeviceSelectRow={props.renderDeviceSelectRow}
                renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
                renderAlertSelectRow={props.renderAlertSelectRow}
                renderAlertSwitchRow={props.renderAlertSwitchRow}
                renderReminderForm={props.renderReminderForm}
              />
            </div>
            :
            null
          }
          {displayDeviceType === "Scale" ?
            <div>
              <DeviceForm
                type={"LESCALE"}
                origin={"creation"}
                get_device_name={props.get_device_name}
                device={{type: "LESCALE", sn: ""}}
                device_list={props.device_list}
                selectedDeviceList={props.selectedDeviceList}
                this_weight_alert={this_weight_alert}
                deviceIdValid={deviceIdValid}
                filterTuckyAOJ20={filterTuckyAOJ20}
                testThermometerType={testThermometerType}
                checkParametersUpdate={checkParametersUpdate}
                cancelPopup={props.cancelPopup}
                handleChangeDeviceId={handleDisplayTuckyParams}
                handleChangeWeightChecked={props.handleChangeWeightChecked}
                handleChangeWeightThreshold={props.handleChangeWeightThreshold}
                handleChangeWeightThreshold2={props.handleChangeWeightThreshold2}
                handleChangeWeightDelay={props.handleChangeWeightDelay}
                checkedWeight={props.checkedWeight}
                renderDeviceSelectRow={props.renderDeviceSelectRow}
                renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
                renderAlertSelectRow={props.renderAlertSelectRow}
                renderAlertSwitchRow={props.renderAlertSwitchRow}
                renderReminderForm={props.renderReminderForm}
              />
            </div>
            :
            null
          }
          {displayDeviceType === "healthform" ?
            <DeviceForm
              type={"healthform"}
              origin={"creation"}
              features={props.subscription_info.features}
              get_device_name={props.get_device_name}
              device={{type: "healthform", sn: ""}}
              device_list={props.device_list}
              moduleActivation={props.moduleActivation}
              selectedDeviceList={props.selectedDeviceList}
              selectedHealthformType={selectedHealthformType}
              this_eq5d_alert={this_eq5d_alert}
              this_eq5d_scale_alert={this_eq5d_scale_alert}
              this_sf36_alert={this_sf36_alert}
              this_mdasi_alert={this_mdasi_alert}
              deviceIdValid={deviceIdValid}
              renderAlertSelectRow={props.renderAlertSelectRow}
              renderAlertSwitchRow={props.renderAlertSwitchRow}
              renderReminderForm={props.renderReminderForm}
              checkedEQ5D={props.checkedEQ5D}
              checkedEQ5DScale={props.checkedEQ5DScale}
              handleChangeEq5dChecked={props.handleChangeEq5dChecked}
              handleChangeEq5dThreshold={props.handleChangeEq5dThreshold}
              handleChangeEq5dScaleDelay={props.handleChangeEq5dScaleDelay}
              handleChangeEq5dScaleChecked={props.handleChangeEq5dScaleChecked}
              handleChangeEq5dScaleThreshold={props.handleChangeEq5dScaleThreshold}
              handleChangeEq5dDelay={props.handleChangeEq5dDelay}
              checkedSF36={props.checkedSF36}
              handleChangeSf36Checked={props.handleChangeSf36Checked}
              handleChangeSf36Threshold={props.handleChangeSf36Threshold}
              handleChangeSf36Delay={props.handleChangeSf36Delay}
              checkedMDASI={props.checkedMDASI}
              handleChangeMDASIChecked={props.handleChangeMDASIChecked}
              handleChangeMDASIThreshold={props.handleChangeMDASIThreshold}
              handleChangeMDASIDelay={props.handleChangeMDASIDelay}
              renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
              selectHealthformTypeChange={selectHealthformTypeChange}
              setModuleActivation={props.setModuleActivation}
              setSelectedHealthformType={setSelectedHealthformType}
              cancelPopup={props.cancelPopup}

              checkParametersUpdate={checkParametersUpdate}
            />
            :
            null
          }
          {displayDeviceType === "pain" ?
            <DeviceForm
              type={"pain"}
              origin={"creation"}
              get_device_name={props.get_device_name}
              device={{type: "pain", sn: ""}}
              device_list={props.device_list}
              moduleActivation={props.moduleActivation}
              selectedDeviceList={props.selectedDeviceList}
              selectedHealthformType={selectedHealthformType}
              this_pain_alert={this_pain_alert}
              deviceIdValid={deviceIdValid}
              renderAlertSelectRow={props.renderAlertSelectRow}
              renderAlertSwitchRow={props.renderAlertSwitchRow}
              renderReminderForm={props.renderReminderForm}
              checkedPain={props.checkedPain}
              handleChangePainChecked={props.handleChangePainChecked}
              handleChangePainThreshold={props.handleChangePainThreshold}
              handleChangePainThreshold2={props.handleChangePainThreshold2}
              handleChangePainDelay={props.handleChangePainDelay}
              renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
              selectHealthformTypeChange={selectHealthformTypeChange}
              setModuleActivation={props.setModuleActivation}
              setSelectedHealthformType={setSelectedHealthformType}
              cancelPopup={props.cancelPopup}

              checkParametersUpdate={checkParametersUpdate}
            />
            :
            null
          }
          {displayDeviceType === "niv" ?
            <DeviceForm
              type={"niv"}
              origin={"creation"}
              features={props.subscription_info.features}
              get_device_name={props.get_device_name}
              device={{type: "niv", sn: ""}}
              device_list={props.device_list}
              moduleActivation={props.moduleActivation}
              selectedDeviceList={props.selectedDeviceList}
              selectedHealthformType={selectedHealthformType}
              this_breathing_alert={this_breathing_alert}
              this_breathing_leakage_alert={this_breathing_leakage_alert}
              this_breathing_leakage95_alert={this_breathing_leakage95_alert}
              this_breathing_ahi_alert={this_breathing_ahi_alert}
              this_breathing_observance_alert={this_breathing_observance_alert}
              checkedBreathingLeakage95={props.checkedBreathingLeakage95}
              checkedBreathingAhi={props.checkedBreathingAhi}
              handleChangeBreathingLeakage95Checked={props.handleChangeBreathingLeakage95Checked}
              handleChangeBreathingLeakage95Threshold={props.handleChangeBreathingLeakage95Threshold}
              handleChangeBreathingLeakage95Threshold2={props.handleChangeBreathingLeakage95Threshold2}
              handleChangeBreathingAhiChecked={props.handleChangeBreathingAhiChecked}
              handleChangeBreathingAhiThreshold={props.handleChangeBreathingAhiThreshold}
              handleChangeBreathingAhiThreshold2={props.handleChangeBreathingAhiThreshold2}
              deviceIdValid={deviceIdValid}
              renderAlertSelectRow={props.renderAlertSelectRow}
              renderAlertSwitchRow={props.renderAlertSwitchRow}
              renderReminderForm={props.renderReminderForm}
              renderReminderFormNoCheck={props.renderReminderFormNoCheck}
              checkedBreathing={props.checkedBreathing}
              checkedBreathingLeakage={props.checkedBreathingLeakage}
              checkedBreathingObservance={props.checkedBreathingObservance}
              handleChangeBreathingChecked={props.handleChangeBreathingChecked}
              handleChangeBreathingThreshold={props.handleChangeBreathingThreshold}
              handleChangeBreathingThreshold2={props.handleChangeBreathingThreshold2}
              handleChangeBreathingLeakageChecked={props.handleChangeBreathingLeakageChecked}
              handleChangeBreathingLeakageThreshold={props.handleChangeBreathingLeakageThreshold}
              handleChangeBreathingLeakageThreshold2={props.handleChangeBreathingLeakageThreshold2}
              handleChangeBreathingObservanceChecked={props.handleChangeBreathingObservanceChecked}
              handleChangeBreathingObservanceThreshold={props.handleChangeBreathingObservanceThreshold}
              handleChangeDeviceId={handleDisplayTuckyParams}
              renderAlertThreshold={props.renderAlertThreshold}
              renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
              renderAlertThresholdAndDelayRowNoCheck={props.renderAlertThresholdAndDelayRowNoCheck}
              renderDeviceSelectRow={props.renderDeviceSelectRow}
              setModuleActivation={props.setModuleActivation}
              setSelectedHealthformType={setSelectedHealthformType}
              cancelPopup={props.cancelPopup}
              checkParametersUpdate={checkParametersUpdate}
              renderReminderFormNoCheck={props.renderReminderFormNoCheck}
            />
            :
            null
          }
          {displayDeviceType === "oxigen_therapy" ?
            <DeviceForm
              type={"oxigen_therapy"}
              origin={"creation"}
              features={props.subscription_info.features}
              get_device_name={props.get_device_name}
              device={{type: "oxigen_therapy", sn: ""}}
              device_list={props.device_list}
              moduleActivation={props.moduleActivation}
              selectedDeviceList={props.selectedDeviceList}
              selectedHealthformType={selectedHealthformType}
              this_breathing_oxygen_rate_alert={this_breathing_oxygen_rate_alert}
              this_spo2_alert={this_spo2_alert}
              deviceIdValid={deviceIdValid}
              renderAlertSelectRow={props.renderAlertSelectRow}
              renderAlertSwitchRow={props.renderAlertSwitchRow}
              renderReminderForm={props.renderReminderForm}
              renderReminderFormNoCheck={props.renderReminderFormNoCheck}
              checkedBreathingOxygenRate={props.checkedBreathingOxygenRate}
              checkedSPO2={props.checkedSPO2}
              handleChangeBreathingOxygenRateChecked={props.handleChangeBreathingOxygenRateChecked}
              handleChangeBreathingOxygenRateThreshold={props.handleChangeBreathingOxygenRateThreshold}
              handleChangeBreathingOxygenRateThreshold2={props.handleChangeBreathingOxygenRateThreshold2}
              handleChangeBreathingOxygenRateDelay={props.handleChangeBreathingOxygenRateDelay}
              handleChangeSPO2Check={props.handleChangeSPO2Check}
              handleChangeSPO2Threshold={props.handleChangeSPO2Threshold}
              handleChangeSPO2Delay={props.handleChangeSPO2Delay}
              renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
              renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
              renderAlertThresholdAndDelayRowNoCheck={props.renderAlertThresholdAndDelayRowNoCheck}
              setModuleActivation={props.setModuleActivation}
              setSelectedHealthformType={setSelectedHealthformType}
              cancelPopup={props.cancelPopup}
              checkParametersUpdate={checkParametersUpdate}
              renderReminderFormNoCheck={props.renderReminderFormNoCheck}
            />
            :
            null
          }
          {displayDeviceType === "Tucky_smartphone" ?
            <DeviceForm
              type={displayDeviceType}
              origin={"creation"}
              get_device_name={props.get_device_name}
              device={{type: "Tucky", sn: ""}}
              device_list={props.device_list}
              selectedDeviceList={props.selectedDeviceList}
              this_fever_alert={this_fever_alert}
              deviceIdValid={deviceIdValid}
              filterTuckyAOJ20={filterTuckyAOJ20}
              testThermometerType={testThermometerType}
              checkParametersUpdate={checkParametersUpdate}
              cancelPopup={props.cancelPopup}
              handleChangeDeviceId={handleDisplayTuckyParams}
              handleChangeFeverCheck={props.handleChangeFeverCheck}
              handleChangeFeverThreshold={props.handleChangeFeverThreshold}
              handleChangeFeverThreshold2={props.handleChangeFeverThreshold2}
              handleChangeFeverDelay={props.handleChangeFeverDelay}
              handleChangeDetachCheck={props.handleChangeDetachCheck}
              handleChangeBatteryCheck={props.handleChangeBatteryCheck}
              checkedFever={props.checkedFever}
              checkedDetach={props.checkedDetach}
              checkedBattery={props.checkedBattery}
              renderDeviceSelectRow={props.renderDeviceSelectRow}
              renderAlertThresholdAndDelayRow={props.renderAlertThresholdAndDelayRow}
              renderAlertSelectRow={props.renderAlertSelectRow}
              renderAlertSwitchRow={props.renderAlertSwitchRow}
              renderReminderForm={props.renderReminderForm}
            />
            :
            null
          }
          {displayDeviceType === "" ?
            <button onClick={props.cancelPopup} className="btn btn-danger">
              <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
            </button>
            :
            null
          }
        </div>
      </div>
    </div>
  );
}

export default withStyles(Constants.styles)(AddDevicePopup);
